module.exports = __webpack_public_path__ + "instagram-icon-small-d8a251a90c9bc367ff3065c2005bff87.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/instagram-icon-small.svg
// module id = 92
// module chunks = 0